import { 
    createProductDefectAPI,
    getProductAllDefectsAPI,
    getProductDefectByIdAPI,
    getProductDefectResolutionTypesAPI,
    getProductDefectTypesAPI,
    resolveProductDefectAPI,
} from "../../adapter/machineCreationAdapter";

export class MachineDefectFactory {

    constructor () {
        // some code 
    }

    getDefectType = (productId) => {

        let data = {
            product_id: productId
        }
    
        let promise = new Promise(function(resolve, reject) {
            getProductDefectTypesAPI(data).then((res) => {
                // console.log("defect helper then:: " + JSON.stringify(res));
    
                if (res && res.data && res.data.status === 200) {
                    resolve(res.data.data)
                } else {
                        reject("error occured");
                }
            });
        })
    
        return promise;
    }
    
    getDefectResolutionTypes = (productId) => {
    
        let data = {
            product_id: productId
        }
    
        let promise = new Promise(function(resolve, reject) {
            getProductDefectResolutionTypesAPI(data).then((res) => {
                // console.log("getDefectResolutionTypesAPI helper then:: " + JSON.stringify(res));
    
                if (res && res.data && res.data.status === 200) {
                    resolve(res.data.data)
                } else {
                    if (res.data.error) reject(res.data.error.message);
                    else reject("error occured");
                }
            });
        })
    
        return promise;
    }
    
    createDefect = (data) => {
    
        let reqData = {
            machine_id: data.machineId,
            stage_id: data.stageId,
            defect_description: data.defectDescription,
            sub_stage_detail_id: data.subStageDetailId,
            defect_type_id: data.defectTypeId
        }
    
        let promise = new Promise(function(resolve, reject) {
            createProductDefectAPI(reqData).then((res) => {
                // console.log("create defect then:: " + JSON.stringify(res));
    
                if (res && res.data && res.data.status === 200) {
                    resolve(res.data.data)
                } else {
                    if (res.data.error) reject(res.data.error.message);
                    else reject("error occured, Please try again");
                }
            });
        })
    
        return promise;
    }
    
    resolveDefect = (data) => {
    
        let reqData = {
            defect_id: data.defectId,
            resolution_type_id: data.defectTypeId,
            resolution_description: data.defectDescription,
            components: []
        }
    
        if (data.defectedPartArray && data.defectedPartArray.length > 0) {
            let components = data.defectedPartArray.map((defectedComponent) => {
                return {
                    machine_sub_stage_detail_id: defectedComponent.id,
                    component_name: defectedComponent.new_id
                }
            })
            reqData.components = components;
        }
    
        let promise = new Promise(function(resolve, reject) {
            resolveProductDefectAPI(reqData).then((res) => {
                // console.log("create defect then:: " + JSON.stringify(res));
    
                if (res && res.data && res.data.status === 200) {
                    resolve(res.data.data)
                } else {
                    if (res.data.error) reject(res.data.error.message);
                    else reject("error occured, Please try again");
                }
            });
        })
    
        return promise;
    }
    
    getAllDefects = (data) => {
    
        let reqData = {
            machine_id: data.machineId
        }
    
        let promise = new Promise(function(resolve, reject) {
            getProductAllDefectsAPI(reqData).then((res) => {
                // console.log("get all defect then:: " + JSON.stringify(res));
    
                if (res && res.data && res.data.status === 200) {
                    resolve(res.data.data)
                } else {
                    reject("error occured");
                }
            });
        })
    
        return promise;
    }
    
    getDefectById = (data) => {
        let reqData = {
            defect_id: data.defectId
        }
    
        let promise = new Promise(function(resolve, reject) {
            getProductDefectByIdAPI(reqData).then((res) => {
                // console.log("get defect by id then:: " + JSON.stringify(res));
    
                if (res && res.data && res.data.status === 200) {
                    resolve(res.data.data)
                } else {
                    reject("error occured");
                }
            });
        })
    
        return promise;
    }
}

